'use client';

import { useIsAuthenticated } from 'lib/auth/auth.hooks';
import { getCookie } from '@checkatrade/web-utils';
import { useEffect, useState } from 'react';

export function useIsConsumer(): { isConsumer?: boolean; loading: boolean } {
  const isAuth = useIsAuthenticated();
  const [isConsumer, setIsConsumer] = useState<boolean | undefined>(undefined);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Reliant on the 30 day consumer cookie.
    // Cookie is set when one of the following actions is taken:
    // message.sent;
    // send_a_job.sent;
    // raq_after_message.sent;
    // inline_send_a_job.sent;
    // global.call_trader;
    const cookie = getCookie('consumer');
    setIsConsumer(isAuth || !!cookie);
    setLoading(false);
  }, [isAuth]);

  return { isConsumer, loading };
}
